<template>
  <div :style="$cmsStyles('c_29bc69a14328')" class="container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_29bc69a14328', 'f_0001', true)" class="banner-wrapper">
          <div class="banner-inner">
            <h1 class="title">{{ $cms('c_29bc69a14328', 'f_0002', "直播电商合作基地网络") }}</h1>
            <div class="desc">
              {{ $cms('c_29bc69a14328', 'f_0003', "面向全国招募合作基地 复制魔筷核心营销能力") }}
            </div>
            <div class="actions">
              <div class="btn btn-white" @click="onJoinClick(5)">{{ $cms('c_29bc69a14328', 'f_0004', "立即加入合作") }}</div>
            </div>
          </div>
        </div>
        <div class="content-wrapper">
          <div v-show="$cms('c_29bc69a14328', 'f_0005', true)" class="box-1">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_29bc69a14328', 'f_0006', "合作基地生态图谱") }}</h2>
              <div class="box-header-desc">{{ $cms('c_29bc69a14328', 'f_0007', "全国战略布局的直播电商基地，覆盖全产业链的价值赋能") }}</div>
            </div>
            <div class="box-body">
              <div class="item" v-for="item in box1List" :key="item.desc">
                <div class="icon-wrapper">
                  <img :src="item.icon" loading="lazy" alt="">
                </div>
                <div class="num-wrapper">
                  <div class="num">{{ item.num }}</div>
                  <div class="plus" v-if="item.plus">+</div>
                </div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>

          <div v-show="$cms('c_29bc69a14328', 'f_0008', true)" class="box-2">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_29bc69a14328', 'f_0009', "战略合作示范基地") }}</h2>
              <div class="box-header-desc">{{ $cms('c_29bc69a14328', 'f_0010', "行业领先的直播电商基地") }}</div>
            </div>
            <div class="box-body">
              <div class="item" v-for="item in box2_1List" :key="item.title">
                <img class="img" :src="item.img" alt="">
                <div class="info">
                  <div class="title">{{ item.title }}</div>
                  <div class="address">
                    <img class="address-icon" :src="$cms('c_29bc69a14328', 'f_0011', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813113913180000423.17550563529143656.png&quot;)" alt="">
                    {{ item.address }}
                  </div>
                  <div class="data-box">
                    <div class="data-item" v-for="data in item.data" :key="data.desc">
                      <div class="num-line">
                        <div class="num">{{ data.num }}</div>
                        <div class="unit">{{ data.unit }}</div>
                        <div class="plus" v-if="data.plus">+</div>
                      </div>
                      <div class="text-line">{{ data.desc }}</div>
                    </div>
                  </div>
                  <div class="desc" v-html="$cmsHtml(item.desc)"></div>
                </div>
              </div>
            </div>
            <div class="box-body box-body_2">
              <div class="item" v-for="item in box2_2List" :key="item.title">
                <img class="img" :src="item.img" alt="">
                <div class="info">
                  <div class="title">{{ item.title }}</div>
                  <div class="address">
                    <img class="address-icon" :src="$cms('c_29bc69a14328', 'f_0012', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813113913180000423.17550563529143656.png&quot;)" alt="">
                    {{ item.address }}
                  </div>
                  <div class="data-box">
                    <div class="data-item" v-for="data in item.data" :key="data.desc">
                      <div class="num-line">
                        <div class="num">{{ data.num }}</div>
                        <div class="unit">{{ data.unit }}</div>
                        <div class="plus" v-if="data.plus">+</div>
                      </div>
                      <div class="text-line">{{ data.desc }}</div>
                    </div>
                  </div>
                  <div class="desc" v-html="$cmsHtml(item.desc)"></div>
                </div>
              </div>
            </div>
          </div>

          <div v-show="$cms('c_29bc69a14328', 'f_0013', true)" class="box-3">
            <div class="box-header">
              <h2 class="box-header-title">{{ $cms('c_29bc69a14328', 'f_0014', "基地合作赋能之路") }}</h2>
              <div class="box-header-desc">{{ $cms('c_29bc69a14328', 'f_0015', "四步极速接入直播电商全渠道，激活增长新动能") }}</div>
            </div>
            <div class="box-content">
              <div class="item" v-for="item in box3List" :key="item.title">
                <img class="index-icon-img" :src="item.indexIcon" loading="lazy" :alt="item.title">
                <img class="icon-img" :src="item.icon" loading="lazy" alt="">
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.desc }}</div>
                <img class="arrow-img" :src="$cms('c_29bc69a14328', 'f_0016', &quot;https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731112742360000176.17539324622252240.png&quot;)" alt="">
              </div>
            </div>
          </div>

          <div v-show="$cms('c_29bc69a14328', 'f_0017', true)" class="box-4">
            <div class="title">{{ $cms('c_29bc69a14328', 'f_0018', "基地加盟合作") }}</div>
            <div class="desc">{{ $cms('c_29bc69a14328', 'f_0019', "加入行业TOP级直播电商生态，共享千亿流量红利与技术赋能资源") }}</div>
            <div class="btn-box">
              <div class="btn" @click="onJoinClick(5)">{{ $cms('c_29bc69a14328', 'f_0020', "立即加入合作") }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue'

export default {
  components: {
    ToolsBar,
  },
  head() { return this.$cmsHead('c_29bc69a14328', {
    title: '基地加盟-直播电商合作基地网络|全域直播电商生态链|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '基地加盟,直播电商基地,战略合作,示范基地,全域生态链,品牌增长,产业链赋能,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '魔筷科技直播电商合作基地网络，打造全域直播电商生态链，共享品牌增长新红利。全国战略布局的直播电商基地，覆盖全产业链的价值赋能，为合作伙伴提供专业的基地合作服务。',
      },
    ],
  }); },
  data() {
    return {
      videoSrc: "",
      box1List: this.$cms('c_29bc69a14328', 'f_0021', [{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250730181126120000299.17538702859924828.png","num":20,"plus":true,"desc":"全国合作基地"},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250730181126120000299.17538702859924828.png","num":100,"plus":true,"desc":"合作品牌集团"},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250730181126120000299.17538702859924828.png","num":20,"plus":true,"desc":"城市布局"}]),
      box2_1List: this.$cms('c_29bc69a14328', 'f_0022', [{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805191027440000420.17543922272564990.png","title":"魔筷传媒大连直播基地","address":"大连市普兰店区金悦湾魔筷直播基地","data":[{"num":20,"unit":"万","plus":true,"desc":"合作达人数量"},{"num":200,"plus":true,"desc":"签约达人数量"}],"desc":"专注短视频电商达人孵化与赋能，集达人培训、流量加持、供应链护航、内容策划于一体。提供专业直播间、拍摄间与成熟变现模式，助力主播快速变现"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805191027440000164.17543922272596669.png","title":"沈阳魔筷直播基地","address":"中国辽宁省沈阳市铁西区建设中路1号(铁西广场地铁站B口步行200米)  第一商城B座 2001","data":[{"num":100,"unit":"场","plus":true,"desc":"每月开播专场"},{"num":10000,"plus":true,"desc":"合作品牌"}],"desc":"东北电商孵化基地｜20+专业直播间×快手认证操盘团队实战赋能，为怀揣电商梦的达人与基地合伙人提供集专业设施、平台特权、大咖操盘于一体的高能创业生态"}]),
      box2_2List: this.$cms('c_29bc69a14328', 'f_0023', [{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20260316093228820000807.17736247486771333.png","title":"宝鸡魔筷直播基地","address":"陕西省宝鸡市渭滨区桥南街道办事处滨河南路互联网产业园","data":[{"num":5,"unit":"万","plus":true,"desc":"合作主播数量"},{"num":2000,"plus":true,"desc":"合作品牌"}],"desc":"依托宝鸡互联网产业园区载体，聚焦区域主播孵化、本地供应链对接及直播带货落地，为区域达人提供培训、流量与变现支持。"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20260316093228820000415.17736247486741970.png","title":"朝阳魔筷直播基地","address":"辽宁省朝阳市龙城区文化路五段","data":[{"num":3,"unit":"万","plus":true,"desc":"合作主播数量"},{"num":2000,"plus":true,"desc":"合作品牌"}],"desc":"立足辽西区位优势，打造区域直播电商生态枢纽，专注本地达人培育、货品上行与电商技能普及，助力传统产业数字化转型"}]),
      box3List: this.$cms('c_29bc69a14328', 'f_0024', [{"indexIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100420620000622.17539274601842903.png","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100501690000432.17539275014186652.png","title":"基地资质评估","desc":"提交基地基础资料，3个工作日内完成合作审核准入"},{"indexIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100420620000689.17539274601822383.png","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100501690000912.17539275014169246.png","title":"定制专属方案","desc":"专业团队规划基地全链运营体系，进行直播电商生态价值赋能"},{"indexIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100420620000688.17539274601816192.png","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100501690000128.17539275014154367.png","title":"资源矩阵对接","desc":"接入选品中心、主播资源库以及流量扶持体系"},{"indexIcon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100420620000359.17539274601789288.png","icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100501690000432.17539275014186652.png","title":"全域直播启动","desc":"开播支持与数据驱动运营"}])
    }
  },
  methods: {
    onJoinClick(type) {
      this.$router.push(`/apply-join?type=${type}`)
    },
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-color: #00092a;
    background-image: var(--cms-c_29bc69a14328-f_0025, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250730175454060000372.17538692939166129.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    .banner-inner {
      .pxToVw(padding-left, 280);
    }
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
      .btn {
        box-sizing: border-box;
        .pxToVw(width, 220);
        .pxToVw(height, 60);
        .pxToVw(line-height, 60);
        text-align: center;
        .pxToVw(margin-right, 40);
        border: 1px solid #fff;
        .pxToVw(border-radius, 30);
        .pxToVw(font-size, 24);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border: none;
          background-color: #fff;
          color: #333;
        }
        &.btn-white {
          background-color: #fff;
          color: #ff6600;
          &:hover {
            background-color: #ff6600;
            color: #fff;
          }
        }
      }
    }
  }
  .content-wrapper {
    .box-header {
      .pxToVw(padding-top, 92);
      color: #333333;
      &-title {
        margin: 0 auto 8 * @unitVw;
        text-align: center;
        .pxToVw(line-height, 50);
        .pxToVw(font-size, 36);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        .pxToVw(margin-bottom, 26);
        position: relative;
        &::after {
          content: "";
          position: absolute;
          .pxToVw(top, 56);
          left: 50%;
          .pxToVw(width, 140);
          height: 1px;
          background: #d8d8d8;
          transform: translateX(-50%);
        }
      }
      &-desc {
        text-align: center;
        .pxToVw(line-height, 25);
        .pxToVw(font-size, 18);
        font-weight: 300;
        color: #666;
      }
    }
    .box-1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      .box-body {
        .pxToVw(border-radius, 20);
        background-image: var(--cms-c_29bc69a14328-f_0026, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250730180241530000862.17538697613853908.jpg?x-oss-process=image/quality,Q_80"));
        background-size: cover;
        background-repeat: no-repeat;
        .pxToVw(height, 363);
        .pxToVw(width, 1440);
        display: flex;
        .pxToVw(margin-top, 60);
        .pxToVw(margin-bottom, 80);
        .item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;
          .icon-wrapper {
            position: relative;
            .pxToVw(height, 120);
            .pxToVw(width, 120);
            border-radius: 50%;
            background: #FFF;
            position: relative;
            .pxToVw(margin-bottom, 30);
            img {
              .pxToVw(width, 54);
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
          .num-wrapper {
            display: flex;
            align-items: center;
            .num {
              font-family: DINCond-Light, DINCond;
              font-weight: 300;
              .pxToVw(font-size, 60);
              color: #333333;
              .pxToVw(line-height, 68);
              text-align: left;
              font-style: normal;
              .pxToVw(margin-right, 10);
            }
            .plus {
              line-height: 1.4;
              .pxToVw(font-size, 20);
              font-weight: 100;
              color: #333;
            }
          }
          .desc {
            .pxToVw(font-size, 18);
            font-weight: 300;
            color: #666666;
            .pxToVw(line-height, 25);
            text-align: right;
            font-style: normal;
          }
        }
      }
    }

    .box-2 {
      .pxToVw(height, 1540);
      background: linear-gradient( 133deg, #00092A 0%, #001554 100%);
      .box-header {
        color: #fff;
        &-desc {
          color: #fff;
        }
      }
      .box-body {
        display: flex;
        .pxToVw(padding-left, 200);
        .pxToVw(padding-right, 200);
        .pxToVw(padding-top, 40);
        .item {
          display: flex;
          flex: 1;
          .pxToVw(padding-left, 15);
          position: relative;
          .img {
            .pxToVw(width, 400);
            .pxToVw(height, 400);
          }
          .info {
            position: absolute;
            .pxToVw(left, 120);
            .pxToVw(top, 160);
            .pxToVw(width, 540);
            .pxToVw(height, 408);
            box-sizing: border-box;
            background: #FFFFFF;
            .pxToVw(border-radius, 16);
            .pxToVw(padding, 38);
            .title {
              font-weight: 600;
              .pxToVw(font-size, 28);
              .pxToVw(line-height, 40);
              color: #333333;
              font-style: normal;
            }
            .address {
              font-weight: 300;
              .pxToVw(font-size, 18);
              .pxToVw(line-height, 25);
              color: #888888;
              font-style: normal;
              display: flex;
              align-items: center;
               .pxToVw(padding-top, 23);
              .address-icon {
                .pxToVw(width, 25);
                .pxToVw(margin-right, 10);
              }
            }
            .data-box {
              display: flex;
              align-items: flex-start;
              .pxToVw(padding-top, 38);
              .pxToVw(padding-bottom, 38);
              .data-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                align-items: center;
           
                .num-line {
                  display: flex;
                  align-items: flex-end;
                  .text {
                    .pxToVw(margin-bottom, 10);
                  }
                  .num {
                    .pxToVw(line-height, 68);
                    .pxToVw(font-size, 60);
                    font-family: DINCond-Light, DINCond;
                    font-weight: 300;
                    color: #333;
                  }
                  .text,
                  .unit,
                  .plus {
                    line-height: 1.4;
                    .pxToVw(font-size, 20);
                    font-family: PingFangSC-Thin, PingFang SC;
                    font-weight: 100;
                    color: #333;
                  }
                  .unit {
                    .pxToVw(margin-bottom, 10);
                  }
                  .plus {
                    align-self: center;
                  }
                }
                .text-line {
                  .pxToVw(line-height, 25);
                  .pxToVw(font-size, 18);
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 300;
                  color: #666;
                  text-align: center;
                }
              }
              
            }
            .desc {
              font-weight: 300;
              .pxToVw(font-size, 18);
              .pxToVw(line-height, 26);
              color: #666666;
              font-style: normal;
              text-align: center;
            }
          }
        }
      }
      .box-body_2 {
        .pxToVw(margin-top, 220);
      }
    }

    .box-3 {
      background-image: var(--cms-c_29bc69a14328-f_0027, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731100057680000169.17539272572808875.jpg?x-oss-process=image/quality,Q_80"));
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .pxToVw(height, 692);
      .pxToVw(padding-left, 240);
      .pxToVw(padding-right, 240);
      .box-content {
        display: flex;
        .pxToVw(gap, 117);
        .pxToVw(padding-top, 60);
        .item {
          flex: 1;
          .pxToVw(height, 360);
          background: #FFFFFF;
          .pxToVw(border-radius, 16);
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          &:last-child {
            .arrow-img {
              display: none;
            }
          }
          .arrow-img {
            position: absolute;
            display: block;
            .pxToVw(height, 16);
            .pxToVw(right, 0);
            top: 50%;
            transform: translate(100%, -50%);
            display: block;
          }
          .index-icon-img {
            position: absolute;
            top: 0;
            .pxToVw(left, 12);
            .pxToVw(top, 15);
            display: block;
            .pxToVw(width, 86);
          }
          .icon-img {
            .pxToVw(left, 12);
            display: block;
            .pxToVw(width, 54);
            .pxToVw(margin-top, 103);
          }
          .title {
            font-weight: 600;
            font-size: 24px;
            color: #333333;
            line-height: 33px;
            text-align: right;
            font-style: normal;
            .pxToVw(padding-top, 35);
            .pxToVw(padding-bottom, 12);
          }
          .desc {
            font-weight: 400;
            .pxToVw(width, 210);
            .pxToVw(font-size, 14);
            .pxToVw(line-height, 20);
            text-align: center;
            color: #666666;
            font-style: normal;
          }
        }
      }
      
    }

    .box-4 {
      .pxToVw(height, 692);
      background-image: var(--cms-c_29bc69a14328-f_0028, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250731112840050000215.17539325197325854.png"));
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: #001554;
      .pxToVw(width, 1440);
      .pxToVw(height, 500);
      .pxToVw(border-radius, 16);
      filter: blur(0px);
      margin: 0 auto;
      .pxToVw(margin-top, 80);
      .pxToVw(margin-bottom, 80);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .title {
        font-weight: 500;
        .pxToVw(font-size, 60);
        color: #FFFFFF;
        .pxToVw(line-height, 84);
        text-align: right;
        font-style: normal;
      }
      .desc {
        font-weight: 300;
        .pxToVw(font-size, 24);
        color: #FFFFFF;
        .pxToVw(line-height, 36);
        text-align: right;
        font-style: normal;
        .pxToVw(margin-top, 20);
        .pxToVw(margin-bottom, 60);
      }
      .btn-box {
        .pxToVw(width, 220);
        .pxToVw(height, 60);
        .pxToVw(line-height, 60);
        text-align: center;
        .pxToVw(border-radius, 30);
        background: #FFFFFF;
        color: #FF6600;
        font-weight: 400;
        .pxToVw(font-size, 24);
        cursor: pointer;
      }
    }
  }
}
</style>
